<template>
  <section class="today" id="todaysection">
    <div class="today__date-container">
      <div class="today__date-container--date u-text-center">
        {{ showDate }}
      </div>
      <p>{{ min }}</p>
      <!-- <div class="today__date-container--time">{{showClock}}</div> -->
      <div class="today__date-container--hijri">
        <span class="today__date-container--hijri--text">{{ showHirji }}</span>
      </div>
    </div>
    <div class="today__salah">
      <div class="row">
        <div class="col-1-of-3">
          <div class="today__salah-container style-fajr" ref="fajr">
            <h1 class="today__salah-container--name">Fajr</h1>
            <h1 class="today__salah-container--time fajr">{{ fajr }}</h1>
          </div>
        </div>
        <div class="col-1-of-3">
          <div class="today__salah-container style-sunrise" ref="sunrise">
            <h1 class="today__salah-container--name">Sunrise</h1>
            <h1 class="today__salah-container--time sunrise">{{ sunrise }}</h1>
          </div>
        </div>
        <div class="col-1-of-3">
          <div class="today__salah-container style-zuhr" ref="zuhr">
            <h1 class="today__salah-container--name">Zuhr</h1>
            <h1 class="today__salah-container--time zuhr">{{ zuhr }}</h1>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-1-of-3">
          <div class="today__salah-container style-asr" ref="asr">
            <h1 class="today__salah-container--name">Asr</h1>
            <h1 class="today__salah-container--time asr">{{ asr }}</h1>
          </div>
        </div>
        <div class="col-1-of-3">
          <div class="today__salah-container style-magrib" ref="magrib">
            <h1 class="today__salah-container--name">Magrib</h1>
            <h1 class="today__salah-container--time magrib">{{ magrib }}</h1>
          </div>
        </div>
        <div class="col-1-of-3">
          <div class="today__salah-container style-isha" ref="isha">
            <h1 class="today__salah-container--name">Isha</h1>
            <h1 class="today__salah-container--time isha">{{ isha }}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { timePrefix, monthNamesAR } from "./../../helpers";
import img from "./../../assets/apple-touch-icon-57x57.png";
export default {
  props: ["today"],
  data() {
    return {
      fajr: "",
      sunrise: "",
      zuhr: "",
      asr: "",
      magrib: "",
      isha: "",
      showClock: "",
      timer: null,
      showDate: "",
      showHirji: "",
      isFajr: false,
      min: "",
    };
  },
  methods: {
    showNotification(body) {
      Notification.requestPermission(function(result) {
        if (result === "granted") {
          navigator.serviceWorker.ready.then(function(registration) {
            registration.showNotification("قَدْ قَامَتِ ٱلصَّلَوٰةُ", {
              body: body,
              icon: img,
              vibrate: [200, 100, 200, 100, 200, 100, 200],
              //tag: "vibration-sample"
              data: {
                dateOfArrival: Date.now(),
                primaryKey: 1,
              },
            });
          });
        }
      });
    },

    displayNotification(body, notification) {
      if (Notification.permission == "granted") {
        /* navigator.serviceWorker.getRegistration().then(function(reg) { */
        navigator.serviceWorker.getRegistration().then(function(reg) {
          var options = {
            body: body,
            icon: img,
            vibrate: [200, 100, 200, 100, 200, 100, 200],
            data: {
              dateOfArrival: Date.now(),
              primaryKey: 1,
            } /*  ,
            actions: [
              {
                action: "explore",
                title: "Explore this new world",
                icon: img
              },
              {
                action: "close",
                title: "Close notification",
                icon: img
              }
            ]  */,
          };
          reg.showNotification(notification, options);
        });
      }
    },

    showNotificationxx() {
      navigator.serviceWorker.ready.then(function(registration) {
        registration.showNotification("Vibration Sample", {
          body: "Buzz! Buzz!",
          icon: "../../assets/apple-touch-icon-57x57.png",
          vibrate: [200, 100, 200, 100, 200, 100, 200],
          tag: "vibration-sample",
        });
      });
    },

    //Current time notification
    prayerUpNotification(hm, s, announcement, item) {
      if (hm === announcement && s > "00") {
        let marker = item;

        if (s < "58") {
          if (s % 2 === 0) {
            marker.classList.add("prayers-up-dash");
            marker.classList.remove("prayers-up-solid");
          } else {
            marker.classList.remove("prayers-up-dash");
            marker.classList.add("prayers-up-solid");
          }
        } else {
          marker.classList.remove("prayers-up-dash");
          marker.classList.remove("prayers-up-solid");
        }
      }
    },
  },
  mounted() {
    /*     Notification.requestPermission().then(status => {
      if (status == "granted") {
        return;
      }
    }); */
    this.timer = setInterval(() => {
      let time = new Date();
      let h =
        time.getHours() < 10 ? "0".concat(time.getHours()) : time.getHours();
      let m =
        time.getMinutes() < 10
          ? "0".concat(time.getMinutes())
          : time.getMinutes();
      let s =
        time.getSeconds() < 10
          ? "0".concat(time.getSeconds())
          : time.getSeconds();
      this.showClock = h + ":" + m + ":" + s;

      let hm = h + ":" + m;
      //Fajr styles
      if (hm === this.fajr && s === "00") {
        let notification = "Fajr " + this.fajr;
        this.showNotification(notification);
      }

      if (hm === this.zuhr && s === "00") {
        let notification = "Zuhr " + this.zuhr;
        this.showNotification(notification);
      }
      if (hm === this.asr && s === "00") {
        let notification = "Asr " + this.asr;
        this.showNotification(notification);
      }
      if (hm === this.magrib && s === "00") {
        let notification = "Magrib " + this.magrib;
        this.showNotification(notification);
      }
      if (hm === this.isha && s === "00") {
        let notification = "Isha " + this.isha;
        this.showNotification(notification);
      }

      //Announcements
      //this.prayerUpNotification(hm, s, this.fajr, this.$refs.fajr);
      //this.prayerUpNotification(hm, s, this.zuhr, this.$refs.zuhr);
      //this.prayerUpNotification(hm, s, this.asr, this.$refs.asr);
      //this.prayerUpNotification(hm, s, this.magrib, this.$refs.magrib);
      //this.prayerUpNotification(hm, s, this.isha, this.$refs.isha);
    }, 1000);
  },
  created() {
    this.fajr =
      timePrefix(this.today["fajr"]["hour"]) +
      ":" +
      timePrefix(this.today["fajr"]["minute"]);
    this.sunrise =
      timePrefix(this.today["sunrise"]["hour"]) +
      ":" +
      timePrefix(this.today["sunrise"]["minute"]);
    this.zuhr =
      timePrefix(this.today["zuhr"]["hour"]) +
      ":" +
      timePrefix(this.today["zuhr"]["minute"]);
    this.asr =
      timePrefix(this.today["asr"]["hour"]) +
      ":" +
      timePrefix(this.today["asr"]["minute"]);
    this.magrib =
      timePrefix(this.today["magrib"]["hour"]) +
      ":" +
      timePrefix(this.today["magrib"]["minute"]);
    this.isha =
      timePrefix(this.today["isha"]["hour"]) +
      ":" +
      timePrefix(this.today["isha"]["minute"]);

    //Gregorain date
    let date = new Date();
    this.showDate =
      date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
    /* const options = { day: 'numeric', month: 'long', year: 'numeric'}; */
    let hijri = new Intl.DateTimeFormat("en-TN-u-ca-islamic").format(
      Date.now()
    );

    let m = hijri.substring(hijri.indexOf("/") - 2, hijri.indexOf("/")).trim();
    let d = hijri
      .substring(hijri.indexOf("/") + 1, hijri.lastIndexOf("/"))
      .trim();
    let y = hijri
      .substring(hijri.lastIndexOf("/") + 1, hijri.lastIndexOf("/") + 5)
      .trim();

    this.showHirji = d + " " + monthNamesAR[m - 1] + " " + y + " AH";
  },
  destroy() {
    clearInterval(this.timer);
  },
};
</script>
